var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-header'),_vm._v(" "),_c('app-messages'),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animate__animated animate__slideInUp","leave-active-class":"animate__animated animate__slideInDown","mode":"out-in"}},[_c('router-view')],1),_vm._v(" "),_c('app-social-chat'),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11b9ee2a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 352
// module chunks = 10